import { render } from "./SocialItem.vue?vue&type=template&id=30d5ebf4&scoped=true&ts=true"
import script from "./SocialItem.vue?vue&type=script&lang=ts"
export * from "./SocialItem.vue?vue&type=script&lang=ts"

import "./SocialItem.vue?vue&type=style&index=0&id=30d5ebf4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d5ebf4"]])

export default __exports__